import { injectReducer } from 'store/reducers.js'
import { authRoute } from 'helpers/routes'

export const OptionsRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'options',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/OptionsContainer').default

      const actions = require('./modules/options').actions
      const reducer = require('./modules/options').default

      injectReducer(store, { key: 'options', reducer })

      store.dispatch(actions.get())

      cb(null, Container)
    }, 'options')
  }
})

export const NewOptionRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'options/new',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/NewOptionContainer').default

      const reducer = require('./modules/option').default

      injectReducer(store, { key: 'option', reducer })

      cb(null, Container)
    }, 'options')
  }
})

export const EditOptionRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'options/:id/edit',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/EditOptionContainer').default

      const actions = require('./modules/option').actions
      const reducer = require('./modules/option').default

      injectReducer(store, { key: 'option', reducer })

      store.dispatch(actions.get(nextState.params.id))

      cb(null, Container)
    }, 'options')
  }
})

export default function (store) {
  return [
    NewOptionRoute(store),
    EditOptionRoute(store),
    OptionsRoute(store)
  ]
}



// WEBPACK FOOTER //
// ./src/routes/Options/index.js